import { render } from "./assessmentDashboardView.vue?vue&type=template&id=c9b41288&lang=true"
import script from "./assessmentDashboardView.vue?vue&type=script&lang=js"
export * from "./assessmentDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__